module.exports = __webpack_public_path__ + "static/media/Upload.a2091096.svg";